<svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M19.588 2.188A2.512 2.512 0 0 0 17.824.406C16.254 0 10 0 10 0S3.746 0 2.176.406A2.512 2.512 0 0 0 .412 2.188C0 3.776 0 7.089 0 7.089s0 3.313.412 4.901a2.512 2.512 0 0 0 1.764 1.782C3.746 14.178 10 14.178 10 14.178s6.254 0 7.824-.406a2.512 2.512 0 0 0 1.764-1.782C20 10.402 20 7.089 20 7.089s0-3.313-.412-4.901ZM7.955 10.089V4.089l5.236 3-5.236 3Z"
		fill="white"
	/>
</svg>
